import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-section">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column footer-brand">
              <Link to="/">
                <div className="footer-thq-footer-logo-wrapper-elm footer-logo-wrapper">
                  <span className="footer-logo-text">SylliPlan</span>
                </div>
              </Link>
              <p className="footer-description section-content">
                Transforming academic chaos into a structured daily plan. Our
                AI-driven platform parses your syllabus to create the ultimate
                semester roadmap.
              </p>
              <div className="footer-social-links">
                <a href="#">
                  <div aria-label="Facebook" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Instagram" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <rect
                          width="20"
                          height="20"
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="LinkedIn" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                        <circle cx="4" cy="4" r="2"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h3 className="footer-heading section-subtitle">Platform</h3>
              <ul className="footer-link-list">
                <li>
                  <Link to="/">
                    <div className="footer-link">
                      <span>Homepage</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/login">
                    <div className="footer-link">
                      <span>Login</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/sign-up">
                    <div className="footer-link">
                      <span>Sign Up</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/syllabus-upload-planner">
                    <div className="footer-thq-footer-link-elm13 footer-link">
                      <span>Syllabus Upload</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/syllabus-upload-planner">
                    <div className="footer-thq-footer-link-elm14 footer-link">
                      <span>Daily Planner</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/ai-study-helper">
                    <div className="footer-thq-footer-link-elm15 footer-link">
                      <span>AI Study Helper</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/account-subscriptions">
                    <div className="footer-thq-footer-link-elm16 footer-link">
                      <span>Pricing &amp; Plans</span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-heading section-subtitle">Resources</h3>
              <ul className="footer-link-list">
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Study Guides</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Student Success Blog</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Knowledge Base</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>Community Forum</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div className="footer-link">
                      <span>API Documentation</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-heading section-subtitle">Stay Updated</h3>
              <p className="footer-newsletter-text section-content">
                Get tips on semester planning and AI study hacks directly in
                your inbox.
              </p>
              <form
                action="/subscribe"
                method="POST"
                data-form-id="fb17bfe9-d3f2-4b1a-a7a6-5e27f963ec54"
                className="footer-newsletter-form"
              >
                <div className="footer-input-group">
                  <input
                    type="email"
                    placeholder="Your college email"
                    aria-label="Email address"
                    required="true"
                    id="thq_textinput_EXYI"
                    name="textinput"
                    data-form-field-id="thq_textinput_EXYI"
                    className="footer-input"
                  />
                  <button
                    type="submit"
                    id="thq_button_cd0L"
                    name="button"
                    data-form-field-id="thq_button_cd0L"
                    className="footer-submit-btn btn btn-primary btn-sm"
                  >
                    Join
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-legal">
              <p className="footer-copyright">
                &amp;copy; 2026 SylliPlan Inc. All rights reserved.
              </p>
              <div className="footer-legal-links">
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Cookie Settings</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.footer-social-icon, .footer-link, .footer-legal-link {
  transition: none;
  transform: none !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<script defer data-name="footer-newsletter">
(function(){
  const newsletterForm = document.querySelector(".footer-newsletter-form")
  const newsletterInput = document.querySelector(".footer-input")

  if (newsletterForm) {
    newsletterForm.addEventListener("submit", (e) => {
      const emailValue = newsletterInput.value

      if (emailValue) {
        const submitBtn = newsletterForm.querySelector(".footer-submit-btn")
        const originalText = submitBtn.textContent

        submitBtn.disabled = true
        submitBtn.textContent = "Subscribed!"
        submitBtn.style.backgroundColor = "#2ecc71"
        submitBtn.style.borderColor = "#2ecc71"

        setTimeout(() => {
          newsletterForm.reset()
          submitBtn.disabled = false
          submitBtn.textContent = originalText
          submitBtn.style.backgroundColor = ""
          submitBtn.style.borderColor = ""
        }, 3000)
      }
    })
  }

  const footerLinks = document.querySelectorAll(".footer-link")
  footerLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      link.style.transition = "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
